// import React from "react";
import {
    // Paper,
    Stack,
    Typography,
    Box,
    Tooltip,
    IconButton
} from "@mui/material";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function SummaryCards({ orders }) {

    const totalOrderPrice = orders.reduce((sum, item) => {
        if (item.OrderStat === "Cancelled") return sum;

        return (
            sum +
            Number(item.Price || 0) * Number(item.ItemQty || 0)
        );
    }, 0);

    const totalSF = orders.reduce((sum, item) => {
        if (item.OrderStat === "Cancelled") return sum;

        return sum + Number(item.SFee || 0);
    }, 0);

    const totalOrderAmount = totalOrderPrice + totalSF;

    const totalDP = orders.reduce((sum, item) => {
        if (item.OrderStat === "Cancelled") return sum;

        return sum + Number(item.PaidAmount || 0);
    }, 0);

    const overallTotal = totalOrderAmount - totalDP;

    const cards = [
        {
            title: "Total Order Price",
            value: totalOrderPrice.toLocaleString(),
            color: "#2563EB",
            description: "Sum of all item prices multiplied by their quantities. Cancelled orders are excluded.",
        },
        {
            title: "Total Shipping Fee",
            value: totalSF.toLocaleString(),
            color: "#D97706",
            description: "Total shipping fees for all active orders.",
        },
        {
            title: "Total Order Amount",
            value: totalOrderAmount.toLocaleString(),
            color: "#7C3AED",
            description: "Total Order Price plus Total Shipping Fee.",
        },
        {
            title: "Total Paid Amount",
            value: `${totalDP.toLocaleString()} / ${totalOrderAmount.toLocaleString()}`,
            color: "#059669",
            description: "Total payments received from customers. Cancelled orders are excluded.",
        },
        // {
        //     title: "Overall Total",
        //     value: overallTotal,
        //     color: "#059669",
        //     description: "Overall amount expected from all active orders.",
        // },
    ];

    return (
        <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            sx={{ mt: 2 }}
        >
            {cards.map((card, index) => (
                <Box
                    key={index}
                    sx={{
                        flex: 1,
                        justifyContent: 'center',
                        p: 1.5,
                        borderRadius: 1,
                        minHeight: 50,
                        minWidth: 200,
                        border: '1px solid #e0e0e0',
                        overflow: "hidden",
                        position: "relative",

                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "4px",
                            backgroundColor: card.color,
                        }
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.5}
                        sx={{ mb: 0.6 }}
                    >
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: "text.secondary",
                                fontWeight: 600,
                            }}
                        >
                            {card.title}
                        </Typography>

                        <Tooltip
                            arrow
                            title={card.description}
                        >
                            <IconButton
                                size="small"
                                sx={{
                                    p: 0,
                                    color: "#9CA3AF",
                                    "&:hover": {
                                        color: card.color,
                                        backgroundColor: "transparent",
                                    },
                                }}
                            >
                                <InfoOutlinedIcon sx={{ fontSize: 15 }} />
                            </IconButton>
                        </Tooltip>
                    </Stack>

                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: "bold",
                            color: card.color,
                        }}
                    >
                        ₱{card.value}
                    </Typography>
                </Box>
            ))}
        </Stack>
    );
}